var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u05EA\u05E4\u201D\u05D9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u05EA\\u05E4\\u201D\\u05D9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "planning-copy",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E1EBF0",
    fillRule: "nonzero",
    cx: 20.4644396,
    cy: 20.4644396,
    r: 20.4644396
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.405941, 1.055446)",
    fill: "#87A0AF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5000337,10.0081406 L35.2788356,10.0081406 C37.1973921,10.0081406 38.7321723,8.47327921 38.7321723,6.55480396 L38.7321723,6.23508515 C38.7321723,4.31652871 37.1973109,2.78174851 35.2788356,2.78174851 L24.2792257,2.78174851 L24.2792257,1.5026297 L35.2788356,1.5026297 C37.9008059,1.5026297 40.0112099,3.61303366 40.0112099,6.23500396 L40.0112099,6.55472277 C40.0112099,9.17677426 37.9008871,11.2871782 35.2788356,11.2871782 L28.5000337,11.2871782 L29.0755762,11.8627208 L28.1163386,12.7580634 L26.0699109,10.6476594 L28.1163386,8.53725545 L29.0755762,9.43259802 L28.5000337,10.0081406 Z M28.5355299,27.2110099 L35.2788356,27.2110099 C37.1973921,27.2110099 38.7321723,25.6761485 38.7321723,23.7576733 L38.7321723,23.4379545 C38.7321723,21.519398 37.1973109,19.9846178 35.2788356,19.9846178 L24.2792257,19.9846178 L24.2792257,18.7055802 L35.2788356,18.7055802 C37.9008059,18.7055802 40.0112099,20.8159842 40.0112099,23.4379545 L40.0112099,23.7576733 C40.0112099,26.3796436 37.9008871,28.4900475 35.2788356,28.4900475 L28.5000337,28.4900475 L29.0755762,29.0655901 L28.1163386,29.9609327 L26.0699109,27.8505287 L28.1163386,25.804101 L29.0755762,26.6993624 L28.5355299,27.2110099 Z M11.5813393,19.6008416 L4.77410495,19.6008416 C2.15213465,19.6008416 0.0417306931,17.4904376 0.0417306931,14.8684673 C0.0417306931,12.246497 2.21611089,10.1360931 4.83808119,10.1360931 L15.8376911,10.1360931 L15.8376911,11.4150495 L4.83808119,11.4150495 C2.91952475,11.4150495 1.38474455,12.9499109 1.38474455,14.8683861 C1.38474455,16.7868614 2.91960594,18.3217228 4.83808119,18.3217228 L11.616802,18.3217228 L11.0413406,17.7462614 L12.0005782,16.8509188 L14.0470059,18.9613228 L12.0005782,21.0077505 L11.0413406,20.1124079 L11.5813393,19.6008416 Z M11.6168832,36.8037109 L4.77410495,36.8037109 C2.15213465,36.8037109 0.0417306931,34.6933069 0.0417306931,32.0713366 C0.0417306931,29.4493663 2.21611089,27.4028574 4.83808119,27.4028574 L15.8376911,27.4028574 L15.8376911,28.681895 L4.83808119,28.681895 C2.91952475,28.681895 1.38474455,30.2167564 1.38474455,32.1352317 C1.38474455,34.0537069 2.91960594,35.5885683 4.83808119,35.5885683 L11.6807782,35.5885683 L11.0413406,34.9491307 L12.0005782,34.0537881 L14.0470059,36.1641921 L12.0005782,38.274596 L11.0413406,37.3792535 L11.6168832,36.8037109 Z M26.7093936,37.1234297 L24.2792257,37.1234297 L24.2792257,35.8443921 L26.7430209,35.8443921 L26.1977822,35.2688495 L27.0931248,34.3735881 L29.1395525,36.4839109 L27.0931248,38.5304198 L26.1977822,37.6350772 L26.7093936,37.1234297 Z M27.2849723,14.8044911 L28.5640099,14.8044911 L28.5640099,16.0835287 L27.2849723,16.0835287 L27.2849723,14.8044911 Z M31.1859802,14.8044911 L32.4650178,14.8044911 L32.4650178,16.0835287 L31.1859802,16.0835287 L31.1859802,14.8044911 Z M35.0230931,14.8044911 L36.3021307,14.8044911 L36.3021307,16.0835287 L35.0230931,16.0835287 L35.0230931,14.8044911 Z M3.81486733,22.7344594 L5.09390495,22.7344594 L5.09390495,24.013497 L3.81486733,24.013497 L3.81486733,22.7344594 Z M7.65189901,22.7344594 L8.93093663,22.7344594 L8.93093663,24.013497 L7.65189901,24.013497 L7.65189901,22.7344594 Z M11.5529069,22.7344594 L12.8319446,22.7344594 L12.8319446,24.013497 L11.5529069,24.013497 L11.5529069,22.7344594 Z M11.1389465,2.78166733 L8.67511287,2.78166733 L8.67511287,1.5026297 L11.138987,1.5026297 L10.5936693,0.927005941 L11.4890119,0.0317445545 L13.5994158,2.14214851 L11.4890119,4.25247129 L10.5936693,3.3572099 L11.1389465,2.78166733 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0091FF",
    fillRule: "nonzero",
    x: 16.2436317,
    y: 35.1092337,
    width: 8.44153465,
    height: 5.18004554
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0374CA",
    fillRule: "nonzero",
    x: 16.2436317,
    y: 26.4758515,
    width: 8.44153465,
    height: 5.18004554
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0091FF",
    fillRule: "nonzero",
    x: 16.2436317,
    y: 17.9063644,
    width: 8.44153465,
    height: 5.18004554
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0374CA",
    fillRule: "nonzero",
    x: 16.2436317,
    y: 9.27290099,
    width: 8.44153465,
    height: 5.18004554
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0091FF",
    fillRule: "nonzero",
    x: 16.2436317,
    y: 0.639518812,
    width: 8.44153465,
    height: 5.18004554
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.405941, 2.516832)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B4D2D7",
    fillRule: "nonzero",
    x: 31.8477446,
    y: 35.1092337,
    width: 8.44153465,
    height: 5.18004554
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B4D2D7",
    fillRule: "nonzero",
    x: 0.639518812,
    y: 0.639518812,
    width: 8.44153465,
    height: 5.18004554
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.00c826374ef5e7cc3f20094ade0fd8b2.svg";
export { ForwardRef as ReactComponent };